module.exports = "/images/vendor/flag-icon-css/flags/4x3/pg.svg?68e1ce3359df0808db9cc34dcb488c4b";